export default __webpack_public_path__ + "static/media/enumerating-employees.d48192c7.png";